/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamItemSubTypesQueryResponse,
  GetApiV1ExamItemSubTypes400,
  GetApiV1ExamItemSubTypes401,
  GetApiV1ExamItemSubTypes500,
} from "../../types/examSharedController/GetApiV1ExamExamItemSubTypes.ts";

function getGetApiV1ExamExamItemSubTypesUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/exam/exam-item-sub-types` as const,
  };
  return res;
}

/**
 * @description Retorna todos os sub tipos de componentes para questões do tipo aberta e multipla linha **(Requer Authorization para autenticação)**
 * @summary Buscar todos os sub tipos de componentes para questões do tipo aberta e multipla linha (Requer Authorization para autenticação)
 * {@link /api/v1/exam/exam-item-sub-types}
 */
export async function getApiV1ExamExamItemSubTypes(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamItemSubTypesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamItemSubTypes400
      | GetApiV1ExamItemSubTypes401
      | GetApiV1ExamItemSubTypes500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamExamItemSubTypesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
